export const getSingleItemNavigationStyle = (components, {
  palette = {},
  iconFontFamily = 'MsAds MDL2 Assets',
} = {}) => ({
  sequentialNavigatorContainer: {
    position: 'absolute',
    bottom: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: 16,
    color: palette.white,
  },
  navigatorStatusContainer: {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '16px',
    margin: '0 12px',
  },
  iconButton: {
    fontFamily: `${iconFontFamily} !important`,
    fontSize: 16,
    lineHeight: 16,
    backgroundColor: 'transparent',
    border: 'none',
    padding: 0,
    color: palette.white,
  },
  chevronLeft: {
    '&:before': {
      content: '"\\E76B"',
    },
  },
  chevronRight: {
    '&:before': {
      content: '"\\E76C"',
    },
  },
  disabledIcon: {
    color: 'rgba(255, 255, 255, 0.5)',
  },
});
